import * as React from 'react';

const BurgerIcon = (props) => (
    <svg width={24} height={24} fill="none" {...props}>
        <path
            stroke="#fff"
            strokeWidth={2}
            d="M2 4c1.842 0 2.158 2.5 4 2.5S8.158 4 10 4s2.158 2.5 4 2.5S16.158 4 18 4s2.158 2.5 4 2.5M2 11c1.842 0 2.158 2.5 4 2.5S8.158 11 10 11s2.158 2.5 4 2.5 2.158-2.5 4-2.5 2.158 2.5 4 2.5M2 18c1.842 0 2.158 2.5 4 2.5S8.158 18 10 18s2.158 2.5 4 2.5 2.158-2.5 4-2.5 2.158 2.5 4 2.5"
        />
    </svg>
);

export default BurgerIcon;
